import React from "react";
import { times } from "lodash";

import { SkeletonSquare, SkeletonRectangle } from "_src/components/Skeleton";

import "./index.less";

export const NavsSkeleton = () => {
  return (
    <>
      {times(3, (key) => (
        <div key={key} className="navs-skeleton-item">
          <SkeletonRectangle className="navs-skeleton-top" />
          <SkeletonRectangle className="navs-skeleton-desc" />
          <SkeletonRectangle className="navs-skeleton-desc" />
          <SkeletonRectangle className="navs-skeleton-desc" />
        </div>
      ))}
    </>
  );
};

export const MediaSkeleton = () => {
  return (
    <>
      {times(4, (key) => (
        <SkeletonSquare key={key} className="media-skeleton-item" />
      ))}
    </>
  );
};
